var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5C16 7.02083 15.4583 8.32292 14.375 9.40625C13.3125 10.4688 12.0208 11 10.5 11C10.1458 11 9.80208 10.9688 9.46875 10.9062L8.71875 11.75C8.57292 11.9167 8.38542 12 8.15625 12H7V13.25C7 13.4583 6.92708 13.6354 6.78125 13.7812C6.63542 13.9271 6.45833 14 6.25 14H5V15.25C5 15.4583 4.92708 15.6354 4.78125 15.7812C4.63542 15.9271 4.45833 16 4.25 16H0.75C0.541667 16 0.364583 15.9271 0.21875 15.7812C0.0729167 15.6354 0 15.4583 0 15.25V12.8125C0 12.6042 0.0729167 12.4271 0.21875 12.2812L5.28125 7.21875C5.09375 6.65625 5 6.08333 5 5.5C5 3.97917 5.53125 2.6875 6.59375 1.625C7.67708 0.541667 8.97917 0 10.5 0C12.0208 0 13.3125 0.541667 14.375 1.625C15.4583 2.6875 16 3.97917 16 5.5ZM10.9375 2.9375C10.6458 3.22917 10.5 3.58333 10.5 4C10.5 4.41667 10.6458 4.77083 10.9375 5.0625C11.2292 5.35417 11.5833 5.5 12 5.5C12.4167 5.5 12.7708 5.35417 13.0625 5.0625C13.3542 4.77083 13.5 4.41667 13.5 4C13.5 3.58333 13.3542 3.22917 13.0625 2.9375C12.7708 2.64583 12.4167 2.5 12 2.5C11.5833 2.5 11.2292 2.64583 10.9375 2.9375Z",
    fill: "#575756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChange);
export default __webpack_public_path__ + "static/media/password-change.efdbdf76d3678e1120f583a4c4c63c8e.svg";
export { ForwardRef as ReactComponent };